/**
 * Return all selected filters from the filterGroups
 * @param {Object[]} filterGroups
 */
const checkedFilters = (filterGroups) => {
    if (!filterGroups) {
        return [];
    }
    const checked = filterGroups.reduce(
        (acc, filterGroup) =>
            acc.concat(
                filterGroup.filters.filter((f) => f.checked).map((f) => f.key)
            ),
        []
    );

    // dedupe and sort
    return [...new Set(checked)].sort();
};

module.exports = {
    checkedFilters
};
